var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.788,
    height: 26.789,
    viewBox: "0 0 26.788 26.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_36",
    "data-name": "Caminho 36",
    d: "M73,83.139h7.654a2.49,2.49,0,0,0,2.487-2.487V73a2.49,2.49,0,0,0-2.487-2.487H73A2.49,2.49,0,0,0,70.51,73v7.653A2.49,2.49,0,0,0,73,83.138Zm7.9-11.365a.957.957,0,1,1-.957.957A.957.957,0,0,1,80.894,71.774ZM76.825,73A3.827,3.827,0,1,1,73,76.824,3.826,3.826,0,0,1,76.825,73Z",
    transform: "translate(-63.43 -63.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M111.107,113.6a2.487,2.487,0,1,0-2.487-2.487A2.487,2.487,0,0,0,111.107,113.6Z",
    transform: "translate(-97.713 -97.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M13.394,26.789A13.395,13.395,0,1,0,0,13.394a13.394,13.394,0,0,0,13.394,13.4ZM5.741,9.567A3.826,3.826,0,0,1,9.567,5.741h7.654a3.826,3.826,0,0,1,3.827,3.827v7.653a3.826,3.826,0,0,1-3.827,3.827H9.567a3.826,3.826,0,0,1-3.827-3.827Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.9ae60843d1ec235af44a6423bdb8425d.svg";
export { ForwardRef as ReactComponent };